import { render, staticRenderFns } from "./scopecity.vue?vue&type=template&id=d5c23a9a&scoped=true&"
import script from "./scopecity.vue?vue&type=script&lang=js&"
export * from "./scopecity.vue?vue&type=script&lang=js&"
import style0 from "./scopecity.vue?vue&type=style&index=0&id=d5c23a9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c23a9a",
  null
  
)

export default component.exports